import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Clock, Play, Loader2 } from "lucide-react";

export const ScheduleCard = ({ cfg, status, set, onRunNow, running }) => {
  const canRun = status?.can_run && !running;
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-4" data-testid="backup-schedule-card">
      <div><h2 className="text-base font-semibold text-slate-900 flex items-center gap-2"><Clock className="h-4 w-4 text-slate-500" />Backup settings</h2><p className="text-xs text-slate-500">Incremental, versions preserved, remote files never deleted, failed transfers retried.</p></div>
      <label className="flex items-center justify-between rounded-lg border border-slate-200 p-3">
        <div><div className="text-sm font-medium text-slate-900">Automatic backup</div><div className="text-xs text-slate-500">Runs on schedule once the provider is connected.</div></div>
        <Switch checked={cfg.auto_enabled} onCheckedChange={(v) => set({ auto_enabled: v })} data-testid="backup-auto-switch" />
      </label>
      <div>
        <Label className="text-xs">Frequency</Label>
        <Select value={String(cfg.frequency_hours)} onValueChange={(v) => set({ frequency_hours: Number(v) })}>
          <SelectTrigger data-testid="backup-frequency-select"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="24">Every 24 hours</SelectItem><SelectItem value="48">Every 48 hours</SelectItem></SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs">Project root folder pattern</Label>
        <Input className="font-mono" value={cfg.root_pattern} onChange={(e) => set({ root_pattern: e.target.value })} data-testid="backup-root-pattern-input" />
        <p className="text-[11px] text-slate-500 mt-1">Tokens: {cfg.pattern_tokens.map((t) => `{${t}}`).join(" ")}</p>
      </div>
      <div className="rounded-lg border border-slate-200 p-3 space-y-2">
        <Button onClick={onRunNow} disabled={!canRun} className="w-full bg-[#2563EB] hover:bg-[#1d4ed8]" data-testid="backup-run-now-btn">
          {running ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Play className="h-4 w-4 mr-2" />}Backup now
        </Button>
        {!status?.can_run && <p className="text-[11px] text-amber-700" data-testid="backup-run-blocked-reason">{status?.run_blocked_reason}. Manual backup is disabled until the destination is connected.</p>}
      </div>
    </div>
  );
};
